/**
 * Created by Kamil.Adamuszek on 2017-04-14.
 */
/**
 * Validation method that test if the field is valid against a phone number.
 */
export var phone = function (value) {
    var phoneNumber = new RegExp('^\\d{8}$');
    return phoneNumber.test(value);
};
